import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.23 11l-.353 2c-.194 1.105-1.248 2-2.352 2-1.105 0-1.842-.895-1.648-2l.353-2c.195-1.105 1.248-2 2.353-2 1.104 0 1.842.895 1.647 2zM13 20c-4.42 0-8-3.58-8-8 0-4.313 3.411-7.816 7.683-7.984 0 0 .24-.016.317-.016 3.591 0 6.5 2.909 6.5 6.5 0 .361-.037.712-.093 1.056-.192 1.173-.692 2.241-1.422 3.113-.005.005-.009.011-.014.016-.221.218-.523.354-.858.354-.676 0-1.224-.548-1.224-1.224 0-.11.02-.336.02-.336L17.051 7h-2l-.142.807C14.264 7.293 13.451 7 12.583 7 10.52 7 8.622 8.604 8.26 10.653l-.352 2c-.197 1.116.088 2.23.783 3.058.687.819 1.72 1.289 2.834 1.289 1.139 0 2.217-.5 3.025-1.283.231.308.498.589.824.799.009.006.018.014.028.02.497.314 1.081.503 1.711.503.876 0 1.67-.354 2.251-.924.031-.034.063-.067.093-.102.068-.072.128-.15.189-.228.06-.076.116-.155.173-.232 1.051-1.415 1.681-3.16 1.681-5.053C21.5 5.813 17.687 2 13 2c-.055 0-.317.016-.317.016C7.311 2.185 3 6.587 3 12c0 5.52 4.48 10 10 10 2.76 0 5.26-1.12 7.07-2.93l-1.412-1.413C17.21 19.105 15.21 20 13 20z",
    fill: "currentColor"
  }));
});